export default __webpack_public_path__ + "static/media/passport-logo-blue-text.a0e8b1e1.svg";